import { HealthSyncMonitoringPage } from "../../features/health-sync-monitoring";

export function AdminHealthSyncPage() {
  return <HealthSyncMonitoringPage />;
}
